export default __webpack_public_path__ + "static/media/t2.a6cb8aa7.png";